import { render, staticRenderFns } from "./AdminUpdateReferralPdfModal.vue?vue&type=template&id=5fb4de7a"
import script from "./AdminUpdateReferralPdfModal.vue?vue&type=script&lang=js"
export * from "./AdminUpdateReferralPdfModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports